import { render, staticRenderFns } from "./ProductDeliveryInfo1.vue?vue&type=template&id=79097526&"
import script from "./ProductDeliveryInfo1.vue?vue&type=script&lang=ts&"
export * from "./ProductDeliveryInfo1.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports